module.exports = __webpack_public_path__ + "media/img/pages/profile/bund ger 6-926f496ea5986ec860b0e62c92993be7.jpg";